import React from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import { ContentZonesService, WindowProxy } from '@sm360/widget-commons-core-services';
import { MEDIA_QUERIES } from '@sm360/widget-commons-general';
import { Quote } from '@sm360/widget-commons-vehicle';

import InstantEstimateIcon from 'trade-in/components/InstantEstimate/InstantEstimateIcon.jsx';
import InstantEstimateAutocomplete from 'trade-in/components/InstantEstimate/InstantEstimateAutocomplete.jsx';
import InstantEstimateModal from 'trade-in/components/InstantEstimateModal/InstantEstimateModal.jsx';
import OfficialTradeInModal from 'trade-in/components/OfficialTradeInModal/OfficialTradeInModal.jsx';
import 'trade-in/components/InstantEstimate/InstantEstimate.scss';

class InstantEstimate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOfficialTradeInModalOpen: false,
            isEstimateTradeInModalOpen: false,
            tradeInVehicle: {},
            inputValue: '',
        };
        this.onValueSelected = this.onValueSelected.bind(this);
        this.getParentSize = this.getParentSize.bind(this);
        this.handleCloseEstimate = this.handleCloseEstimate.bind(this);
        this.handleCloseOfficial = this.handleCloseOfficial.bind(this);
        this.handleResize = debounce(() => this.forceUpdate(), 150).bind(this);
    }

    componentWillMount() {
        const windowProxy = WindowProxy.get();
        if (windowProxy) {
            windowProxy.addEventListener('resize', this.handleResize);
        }
    }

    componentWillUnmount() {
        const windowProxy = WindowProxy.get();
        if (windowProxy) {
            windowProxy.removeEventListener('resize', this.handleResize);
        }
    }

    onValueSelected(inputValue, selectedValue) {
        this.setState({
            inputValue,
            isEstimateTradeInModalOpen: !!selectedValue,
            tradeInVehicle: selectedValue || {},
        });
        // TODO: need 1 news params on the func. "handler" and need to setState : tradeInVehicle as selectedValue
    }

    getParentSize() {
        const windowProxy = WindowProxy.get();
        if (!windowProxy) {
            return null;
        }
        const parent = windowProxy.document.getElementById(this.props.parentElementId);
        if (!parent) {
            return null;
        }
        return parent.offsetWidth;
    }

    getClassNameFromParentSize() {
        const size = this.getParentSize();
        if (!size) {
            return null;
        }
        if (size <= MEDIA_QUERIES.MOBILE.MAX) {
            return 'instant-estimate-mobile';
        }
        if (size >= MEDIA_QUERIES.TABLET.MIN && size <= MEDIA_QUERIES.TABLET.MAX) {
            return 'instant-estimate-tablet';
        }
        return null;
    }

    handleCloseEstimate() {
        this.setState({ isEstimateTradeInModalOpen: false });
    }
    handleCloseOfficial() {
        this.setState({ isOfficialTradeInModalOpen: false });
    }

    render() {
        const czGroup = 'widget.tradein.teaser';
        const styleBackgroundPrimary = {
            backgroundColor: ContentZonesService.getContentZone(czGroup, 'primary.background.color')
                ? ContentZonesService.getContentZone(czGroup, 'primary.background.color').getValue()
                : '#21232e',
        };
        const stylePatternOverlay = {
            backgroundImage:
                ContentZonesService.getContentZone(czGroup, 'pattern') &&
                `url(${ContentZonesService.getContentZone(czGroup, 'pattern').getValue()})`,
        };

        return (
            <div
                className={['instant-estimate__showroom', this.getClassNameFromParentSize()].join(' ').trim()}
                style={styleBackgroundPrimary}
            >
                <div className="instant-estimate__wrapper">
                    <InstantEstimateIcon />
                    <InstantEstimateAutocomplete
                        onAutoCompleteSelect={this.onValueSelected}
                        selectedValue={this.state.inputValue}
                    />
                    {stylePatternOverlay.backgroundImage && (
                        <div className="instant-estimate__pattern" style={stylePatternOverlay} />
                    )}
                </div>
                <InstantEstimateModal
                    openModal={this.state.isEstimateTradeInModalOpen}
                    onClose={this.handleCloseEstimate}
                    tradeInVehicle={this.state.tradeInVehicle}
                    isShowroomV2Enabled={this.props.isShowroomV2Enabled}
                    quote={this.props.quote}
                />
                <OfficialTradeInModal
                    openModal={this.state.isOfficialTradeInModalOpen}
                    onClose={this.handleCloseOfficial}
                    tradeInVehicle={this.state.tradeInVehicle}
                    quote={this.props.quote}
                />
            </div>
        );
    }
}

InstantEstimate.displayName = 'InstantEstimate';

InstantEstimate.propTypes = {
    parentElementId: PropTypes.string.isRequired,
    isShowroomV2Enabled: PropTypes.bool.isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModel).isRequired,
};

export default InstantEstimate;



// WEBPACK FOOTER //
// ./src/components/InstantEstimate/InstantEstimate.jsx